import React, { FC } from 'react';
import { PrimaryButton, SecondaryButton } from '../../components/common/StyledButton';
import { LayoutCentered } from '../../components/layouts/Centered';
import { MetaTags } from '../../components/common/MetaTags';

const PageNotFound: FC = () => {

  const headline = 'Nah…';
  const imageUrl = `${process.env.PUBLIC_URL}/images/404.gif`;

  return (
    <LayoutCentered headline={headline} subHeadline={<>Hier ist nix, sorry.</>} image={{ url: imageUrl }}>
      <MetaTags
        hideTitleTemplate={true}
        metaTitle={'Hier ist nix, sorry'}
        metaDescription={'Diese Seite gibt es leider nicht. Schau doch mal auf unserer Startseite vorbei.'}
      />
      <SecondaryButton href={'/'}>Zur Startseite</SecondaryButton>
      <PrimaryButton href={'mailto:help@boomerjobs.de'}>fehler melden</PrimaryButton>
    </LayoutCentered>
  );
};

export default PageNotFound;
